/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Usage_Overage_Disable_With_Active_OverageInputs */



/**
* | output |
* | --- |
* | "Disabling blocks future overage. Already-incurred overage ({amount}) will still be billed at period close." |
*
* @param {Usage_Overage_Disable_With_Active_OverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_disable_with_active_overage = /** @type {((inputs: Usage_Overage_Disable_With_Active_OverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Disable_With_Active_OverageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Deaktivieren blockiert zukünftigen Überschuss. Bereits angefallener Überschuss (${i?.amount}) wird am Ende des Abrechnungszeitraums dennoch berechnet.`)
	return /** @type {LocalizedString} */ (`Disabling blocks future overage. Already-incurred overage (${i?.amount}) will still be billed at period close.`)
});